import { CheckoutPageMonthlyCombined } from "./CheckoutPageMonthlyCombined";

export function CheckoutPageMonthlyInvite() {
    return <CheckoutPageMonthlyCombined isInvite={true} />;
}